import { BASE_URL } from "@constants/api.constants";
import { uploadImageFile } from "@utils/upload.util";

export const getSiteSettingsInputs = (initialValues) => [
  {
    type: "TEXT",
    label: "Company Name",
    id: "company_name",
    name: "company_name",
    value: initialValues?.company_name || "",
    placeholder: "Enter the Company Name",
    validations: [],
  },
  {
    type: "FILE_UPLOAD",
    label: "Header Logo",
    id: "header_logo",
    name: "header_logo",
    value: initialValues?.header_logo || "",
    filePrefix: BASE_URL + "app-source/images/",
    handleSelfUpload: uploadImageFile,
    validations: [
      {
        type: "REQUIRED",
        message: "Header Logo is required !",
      },
    ],
  },
  {
    type: "TEXT",
    label: "Contact Number",
    id: "contact_number",
    name: "contact_number",
    value: initialValues?.contact_number || "",
    placeholder: "Enter the Contact Number",
    validations: [
      {
        type: "REQUIRED",
        message: "Contact Number is required !",
      },
    ],
  },
  {
    type: "TEXT",
    label: "Contact Email",
    id: "contact_email",
    name: "contact_email",
    value: initialValues?.contact_email || "",
    placeholder: "Enter the Email Address",
    validations: [
      {
        type: "REQUIRED",
        message: "Email is required !",
      },
      {
        type: "EMAIL",
        message: "Please enter a valid email address !",
      },
    ],
  },
  {
    type: "TEXT",
    label: "Address",
    id: "address",
    name: "address",
    value: initialValues?.address || "",
    placeholder: "Enter the Address",
    validations: [
      {
        type: "REQUIRED",
        message: "Address is required !",
      },
    ],
  },
  {
    type: "FILE_UPLOAD",
    label: "Footer Logo",
    id: "footer_logo",
    name: "footer_logo",
    value: initialValues?.footer_logo || "",
    filePrefix: BASE_URL + "app-source/images/",
    handleSelfUpload: uploadImageFile,
    validations: [
      {
        type: "REQUIRED",
        message: "Footer Logo is required !",
      },
    ],
  },
  {
    type: "TEXT_AREA",
    label: "Footer Description",
    id: "footer_description",
    name: "footer_description",
    value: initialValues?.footer_description || "",
    placeholder: "Enter the Footer Description",
    validations: [],
  },
  {
    type: "TEXT_AREA",
    label: "Footer Customer Service",
    id: "footer_customer_service",
    name: "footer_customer_service",
    value: initialValues?.footer_customer_service || "",
    placeholder: "Enter the Footer Customer Service",
    validations: [],
  },
];
